<template>
<bim-row id="how-it-work" class="services-lending__how-work" justify="center">
  <bim-col class="services-lending__info-title" cols="12" order="1">Как это работает?</bim-col>
  
  <bim-col cols="12" order="3" orderSm="2">
    <bim-row justify="center">
      <bim-col 
        v-for="(item, index) in info"
        :key="index"
        class="how-work__column pb-9 pb-sm-0" 
        cols="12" 
        xxl="4" 
        md="6"
      >
        <img 
          class="how-work__image"
          :src="item.image_src"
          :srcset="item.image_srcset"
        />
        <h3 class="how-work__title">{{ item.title }}</h3>
        <p class="how-work__info">{{ item.info }}</p>
      </bim-col>
    </bim-row>
  </bim-col>

  <bim-col cols="12" order="2" orderSm="3">
    <a class="text-link-video" href="#service-video">
      <img src="/dist/assets/front_white/img/svg/play.svg" />
      <span class="text-link-video__text">Посмотреть видео</span>
    </a>
  </bim-col>
</bim-row>
</template>

<script>
import bimRow from '@bimlib/components/bimRow'
import bimCol from '@bimlib/components/bimCol'

const image_path = "/dist/assets/front_white/img/services_lending/how_work/";
export default {
  name: "block-how-work",
  components: {
    bimCol,
    bimRow 
  },
  data() {
    return {
      info: [
        {
          image_src: `${image_path}/typework-1.png`,
          image_srcset: `${image_path}/typework-1@2x.png 2x, ${image_path}/typework-1@3x.png 3x`,
          title: "Собираем, актуализируем и показываем на карте строящиеся объекты в выбранном регионе",
          info: "С быстрым поиском и удобными фильтрами находить нужные объекты еще проще."
        },
        {
          image_src: `${image_path}/typework-2.png`,
          image_srcset: `${image_path}/typework-2@2x.png 2x, ${image_path}/typework-2@3x.png 3x`,
          title: "Выгружаем информацию об объекте и контактные данные для «теплых» звонков",
          info: "Полное описание объекта с адресом и контактными данными лиц, которые принимают решения."
        },
        {
          image_src: `${image_path}/typework-3.png`,
          image_srcset: `${image_path}/typework-3@2x.png 2x, ${image_path}/typework-3@3x.png 3x`,
          title: "Даем сведения обо всех материалах, требующихся на строительной площадке. Показываем цены на сегодня",
          info: "Таблица с ценами и фильтрация по категориям. Показ количества, наименования и плановой стоимости единицы в рублях."
        }
      ]
    }
  }
}
</script>